import React, { useContext } from "react";
import { styled } from "@mui/material/styles";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import SurfingIcon from "@mui/icons-material/Surfing";
import ListItemText from "@mui/material/ListItemText";

import Context from "../../context";
const CustomizedListItemButton = styled(ListItemButton)`
    color: ${(props) => (props.isActive ? "green" : "")};

    :hover {
        color: ${(props) => (props.isActive ? "green" : "")};
    }
    :active {
        color: ${(props) => (props.isActive ? "green" : "")};
    }
`;

const CustomizedIcon = styled(SurfingIcon)`
    color: ${(props) => (props.isActive ? "green" : "")};

    :hover {
        color: ${(props) => (props.isActive ? "green" : "")};
    }
    :active {
        color: ${(props) => (props.isActive ? "green" : "")};
    }
`;

export default function ShowSurfSpotsButton() {
    const { showSurfSpots, setShowSurfSpots } = useContext(Context);

    const isActive = showSurfSpots;
    return (
        <CustomizedListItemButton
            button
            isActive={isActive}
            onClick={() => setShowSurfSpots((isActive) => !isActive)}
        >
            <ListItemIcon>
                <CustomizedIcon isActive={isActive} />
            </ListItemIcon>
            <ListItemText primary={`Surf Reports`} />
        </CustomizedListItemButton>
    );
}
